import Vue from 'vue'
import Flight from './Flight.vue'
import Package from './Package.vue'
import Hotel from './Hotel.vue'
import Tour from './Tour.vue'
import Highlight from './Highlight.vue'
import StaticIBE from './StaticIBE.vue'
import { store } from './store/store'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import hash from './store/modules/hash'
import fecha from 'fecha'
import BananasSettings from './settings/bananas'

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(VueI18n)

let trackHostNames = {}
trackHostNames['www.urlaubspiraten.de'] = 'de-DE' // Germany
trackHostNames['www.urlaubspiraten.at'] = 'de-AT' // Austria
trackHostNames['www.travelpirates.com'] = 'en-US' // USA
trackHostNames['www.holidaypirates.com'] = 'en-GB' // United Kingdom
trackHostNames['www.piratinviaggio.it'] = 'it-IT' // Italy
trackHostNames['www.vakantiepiraten.nl'] = 'nl-NL' // Netherland
trackHostNames['www.wakacyjnipiraci.pl'] = 'pl-PL' // Poland
trackHostNames['www.voyagespirates.fr'] = 'fr-FR' // France
trackHostNames['www.viajerospiratas.es'] = 'es-ES' // Spain
trackHostNames['www.ferienpiraten.ch'] = 'de-CH' // Switzerland
trackHostNames['localhost'] = 'en-US' // for development

// Check if page is open inside an App Browser (standalone) and update storage variable whre default is false
const userAgent = navigator.userAgent
const inAppBrowser =
  userAgent.indexOf('FBAN') >= 0 ||
  userAgent.indexOf('FBAV') >= 0 ||
  userAgent.indexOf('Instagram') >= 0 ||
  userAgent.indexOf('GSA') >= 0
store.dispatch('updateInAppBrowser', inAppBrowser)

let locale = trackHostNames[window.location.hostname]
// Overwrite locale with config
if (window.bananaGlobalConfigData !== undefined) {
  if (window.bananaGlobalConfigData.hasOwnProperty('locale')) {
    locale = window.bananaGlobalConfigData.locale
  }
}

// grab locale from window.settings.site_language_underscore at Cutty-Sark
if (window.settings !== undefined) {
  if (
    window.settings.hasOwnProperty('site_language_underscore') !== undefined
  ) {
    locale = window.settings.site_language_underscore.replace('_', '-')
  }
}

if (document.getElementById('bananas-highlight') != null) {
  // grab locale from data attribute data-bn-locale
  if (
    document
      .getElementById('bananas-highlight')
      .getAttribute('data-bn-locale') !== null
  ) {
    locale = document
      .getElementById('bananas-highlight')
      .getAttribute('data-bn-locale')
  }
}

// Set local with GET param
const urlParams = new URLSearchParams(window.location.search)
if (urlParams.has('bn-locale')) {
  locale = urlParams.get('bn-locale')
}

if (locale === undefined) {
  // Reset when nothing is set for locale
  locale = 'de-DE'
}

// look if hash has parameter
if (window.location.hash !== '') {
  store.registerModule('hash', hash)
  const hashPart = window.location.hash.substring(1)
  const hashParams = hashPart.split('&')
  if (hashParams.includes('mvTranslate')) {
    store.dispatch('setMvTranslate')
  }
  if (hashParams.includes('mvRequest')) {
    store.dispatch('setMvRequest')
  }
  if (hashParams.includes('mvResponse')) {
    store.dispatch('setMvResponse')
  }
}

// Get locale messages
const localMessages = require('./lang/' + locale + '.json')
store.dispatch('updateLocaleMessages', localMessages[locale])
store.dispatch('updateLocale', locale)
const messages = localMessages

// Create VueI18n instance
// Set default language in param locale
const i18n = new VueI18n({
  locale: locale, // set locale
  fallbackLocale: 'de-DE',
  messages // set locale messages
})

// mounting points
let mountingPointHighlights = '#bananas-highlight'
let mountingMain = document.getElementsByClassName('main')

// Check if we have highlightconfigs
if (window.bananasHighlightsConfigData !== undefined) {
  if (mountingMain.length > 0) {
    let mountingNode = document.createElement('div')
    mountingNode.id = 'bananas-highlight'
    if (
      mountingMain[0].children.length >=
      window.bananasHighlightsConfigData.insertAfterDiv
    ) {
      mountingMain[0].children[
        window.bananasHighlightsConfigData.insertAfterDiv - 1
      ].insertAdjacentElement('afterend', mountingNode)
    } else {
      mountingMain[0].children[
        mountingMain[0].children.length - 1
      ].insertAdjacentElement('afterend', mountingNode)
    }
  }
}

window.dataLayer = window.dataLayer || []

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

if (BananasSettings.enabledMarkets.flights.includes(locale)) {
  if (document.getElementById('bananas-flight') != null) {
    const flightElement = document.getElementById('bananas-flight')
    // collect data for package search
    let dataPackage = {}
    dataPackage.cabin = ''
    dataPackage.type = 'return'
    dataPackage.count = parseInt(flightElement.getAttribute('data-bn-count'))
    dataPackage.arrivalAirport = [
      {
        type: 'airport',
        value: flightElement.getAttribute('data-bn-destination-iata')
      }
    ]
    dataPackage.departureAirport = [
      {
        type: 'airport',
        value: flightElement.getAttribute('data-bn-origin-iata')
      }
    ]
    dataPackage.connectioncount = {
      max: parseInt(flightElement.getAttribute('data-bn-maxstopps')),
      min: 0
    }
    dataPackage.arrivalDepTime = {
      end: '',
      start: ''
    }
    dataPackage.departureDepTime = {
      end: '',
      start: ''
    }
    let adults = []
    for (let i = 0; i < flightElement.getAttribute('data-bn-adults'); i++) {
      adults.push({
        type: 'ADT'
      })
    }
    dataPackage.passengers = adults
    const localeObject = locale.split('-')
    dataPackage.country = localeObject[1].toLowerCase()
    dataPackage.language = localeObject[0]
    dataPackage.duration = {
      max: parseInt(flightElement.getAttribute('data-bn-durationmax')),
      min: parseInt(flightElement.getAttribute('data-bn-durationmin'))
    }
    if (flightElement.getAttribute('data-bn-depdate').split('-').length > 1) {
      dataPackage.departureDepTime.start = flightElement.getAttribute(
        'data-bn-depdate'
      )
    } else {
      let startDate = new Date()
      dataPackage.departureDepTime.start = fecha.format(
        startDate.setDate(
          startDate.getDate() +
            parseInt(flightElement.getAttribute('data-bn-depdate'))
        ),
        'YYYY-MM-DD'
      )
    }
    if (flightElement.getAttribute('data-bn-arrdate').split('-').length > 1) {
      dataPackage.departureDepTime.end = flightElement.getAttribute(
        'data-bn-arrdate'
      )
    } else {
      let endDate = new Date()
      dataPackage.departureDepTime.end = fecha.format(
        endDate.setDate(
          endDate.getDate() +
            parseInt(flightElement.getAttribute('data-bn-arrdate'))
        ),
        'YYYY-MM-DD'
      )
    }
    new Vue({
      i18n,
      store,
      render: h =>
        h(Flight, {
          props: { flightData: dataPackage }
        })
    }).$mount('#bananas-flight')
  }
}

if (BananasSettings.enabledMarkets.packages.includes(locale)) {
  if (document.getElementById('bananas-package') != null) {
    const packageElement = document.getElementById('bananas-package')
    // collect data for package search
    let dataPackage = {}
    const origin = packageElement.getAttribute('data-bn-origin-iata')
    if (origin === '') {
      dataPackage.airport = ['FRA', 'DUS', 'TXL', 'SXF', 'HAM', 'MUC']
    } else {
      dataPackage.airport = [origin]
    }
    dataPackage.count = packageElement.getAttribute('data-bn-count')
    const country = packageElement.getAttribute('data-bn-destination-country')
    const region = packageElement.getAttribute('data-bn-destination-region')
    const regionGroup = packageElement.getAttribute(
      'data-bn-destination-regiongroup'
    )
    const city = packageElement.getAttribute('data-bn-destination-city')
    let destinationToSearch = {}
    if (country !== '') {
      destinationToSearch = {
        country: [country]
      }
    }
    if (region !== '') {
      destinationToSearch = {
        region: [region]
      }
    }
    if (regionGroup !== '') {
      destinationToSearch = {
        regiongroup: [regionGroup]
      }
    }
    if (city !== '') {
      destinationToSearch = {
        city: [city]
      }
    }
    dataPackage.maxPricePerPerson = 3000
    dataPackage.destinationToSearch = destinationToSearch
    dataPackage.durationMax = packageElement.getAttribute('data-bn-durationmax')
    dataPackage.durationMin = packageElement.getAttribute('data-bn-durationmin')
    dataPackage.minBoardType = packageElement.getAttribute(
      'data-bn-minboardtype'
    )
    dataPackage.minHotelCategory = packageElement.getAttribute(
      'data-bn-minhotelcategory'
    )
    dataPackage.minHotelRecommendation = packageElement.getAttribute(
      'data-bn-minrecommendation'
    )
    let adults = []
    for (let i = 0; i < packageElement.getAttribute('data-bn-adults'); i++) {
      adults.push({
        type: 'ADT'
      })
    }
    dataPackage.passengers = adults
    const language = locale.split('-')[0]
    dataPackage.language = language
    if (packageElement.getAttribute('data-bn-depdate').split('-').length > 1) {
      dataPackage.startDate = packageElement.getAttribute('data-bn-depdate')
    } else {
      let startDate = new Date()
      dataPackage.startDate = fecha.format(
        startDate.setDate(
          startDate.getDate() +
            parseInt(packageElement.getAttribute('data-bn-depdate'))
        ),
        'YYYY-MM-DD'
      )
    }
    if (packageElement.getAttribute('data-bn-arrdate').split('-').length > 1) {
      dataPackage.endDate = packageElement.getAttribute('data-bn-arrdate')
    } else {
      let endDate = new Date()
      dataPackage.endDate = fecha.format(
        endDate.setDate(
          endDate.getDate() +
            parseInt(packageElement.getAttribute('data-bn-arrdate'))
        ),
        'YYYY-MM-DD'
      )
    }
    new Vue({
      i18n,
      store,
      render: h =>
        h(Package, {
          props: { packageData: dataPackage }
        })
    }).$mount('#bananas-package')
  }
}

if (BananasSettings.enabledMarkets.hotels.includes(locale)) {
  if (document.getElementById('bananas-hotel') != null) {
    const hotelElement = document.getElementById('bananas-hotel')
    // collect data for package search
    let dataPackage = {}
    dataPackage.count = hotelElement.getAttribute('data-bn-count')
    const destinationObject = hotelElement
      .getAttribute('data-bn-destination-payload')
      .split('_')
    dataPackage.destinationToSearch = {}
    dataPackage.destinationToSearch[destinationObject[0]] = [
      destinationObject[1]
    ]
    dataPackage.minHotelCategory = hotelElement.getAttribute(
      'data-bn-minhotelcategory'
    )
    dataPackage.minHotelRecommendation = hotelElement.getAttribute(
      'data-bn-minrecommendation'
    )
    let adults = []
    for (let i = 0; i < hotelElement.getAttribute('data-bn-adults'); i++) {
      adults.push({
        type: 'ADT'
      })
    }
    dataPackage.passengers = adults
    const localeObject = locale.split('-')
    dataPackage.country = localeObject[1]
    dataPackage.language = localeObject[0]
    if (hotelElement.getAttribute('data-bn-depdate').split('-').length > 1) {
      dataPackage.startDate = hotelElement.getAttribute('data-bn-depdate')
      let endDate = new Date(dataPackage.startDate)
      dataPackage.endDate = fecha.format(
        endDate.setDate(endDate.getDate() + 1),
        'YYYY-MM-DD'
      )
    } else {
      let startDate = new Date()
      dataPackage.startDate = fecha.format(
        startDate.setDate(
          startDate.getDate() +
            parseInt(hotelElement.getAttribute('data-bn-depdate'))
        ),
        'YYYY-MM-DD'
      )
      let endDate = new Date(dataPackage.startDate)
      dataPackage.endDate = fecha.format(
        endDate.setDate(endDate.getDate() + 1),
        'YYYY-MM-DD'
      )
    }
    new Vue({
      i18n,
      store,
      render: h =>
        h(Hotel, {
          props: { hotelData: dataPackage }
        })
    }).$mount('#bananas-hotel')
  }
}

if (document.getElementById('bananas-highlight') != null) {
  let searchTag = ''
  if (locale === 'de-DE') {
    searchTag = 'mallorca'
  } else {
    searchTag = 'new York'
  }
  let bananaDestination = document
    .getElementById('bananas-highlight')
    .getAttribute('data-bn-destination')
  if (bananaDestination !== null && bananaDestination !== '') {
    searchTag = bananaDestination
  } else {
    // get searchTag from url
    const urlFullPath = location.pathname
    let urlPath = urlFullPath.split('/')
    // Check if url has a / at the end
    let tagPosition = urlPath.length - 2
    if (urlPath[urlPath.length - 1] !== '') {
      tagPosition = urlPath.length - 1
    }
    if (urlPath[tagPosition] !== '') {
      searchTag = urlPath[tagPosition]
    }
  }
  // get searchTag from GET parameter Overwrite ALL before
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('bn-tag')) {
    searchTag = urlParams.get('bn-tag')
  }
  const headline = document
    .getElementById('bananas-highlight')
    .getAttribute('data-bn-headline')
  const headlineClass = document
    .getElementById('bananas-highlight')
    .getAttribute('data-bn-headline-class')
  new Vue({
    i18n,
    store,
    render: h =>
      h(Highlight, {
        props: {
          searchTag: searchTag,
          headline: headline,
          headlineClass: headlineClass
        }
      })
  }).$mount(mountingPointHighlights)
}

if (BananasSettings.enabledMarkets.packages.includes(locale)) {
  if (document.getElementsByClassName('bananas-static-ibe-wrapper') != null) {
    let staticBananas = document.getElementsByClassName(
      'bananas-static-ibe-wrapper'
    )
    let wrappers = []
    for (let index = 0; index < staticBananas.length; index++) {
      staticBananas[index].setAttribute('id', 'bananas-static-ibe-' + index)
      wrappers.push('bananas-static-ibe-' + index)
    }

    wrappers.forEach((wrapper, index) => {
      new Vue({
        i18n,
        store,
        render: h =>
          h(StaticIBE, {
            props: { parentElement: wrapper, parentIndex: index }
          })
      }).$mount('#' + wrapper)
    })
  }
}

if (BananasSettings.enabledMarkets.tours.includes(locale)) {
  if (document.getElementById('bananas-tour') != null) {
    const tourElement = document.getElementById('bananas-tour')
    // collect data for package search
    let dataPackage = {}
    dataPackage.limit = tourElement.getAttribute('data-bn-count')
    dataPackage.market = locale.toLowerCase()
    dataPackage.searchTerm = tourElement.getAttribute('data-bn-destination')
    if (tourElement.getAttribute('data-bn-depdate').split('-').length > 1) {
      dataPackage.startDate = tourElement.getAttribute('data-bn-depdate')
    } else {
      let startDate = new Date()
      dataPackage.startDate = fecha.format(
        startDate.setDate(
          startDate.getDate() +
            parseInt(tourElement.getAttribute('data-bn-depdate'))
        ),
        'YYYY-MM-DD'
      )
    }
    if (tourElement.getAttribute('data-bn-arrdate').split('-').length > 1) {
      dataPackage.endDate = tourElement.getAttribute('data-bn-arrdate')
    } else {
      let endDate = new Date()
      dataPackage.endDate = fecha.format(
        endDate.setDate(
          endDate.getDate() +
            parseInt(tourElement.getAttribute('data-bn-arrdate'))
        ),
        'YYYY-MM-DD'
      )
    }
    new Vue({
      i18n,
      store,
      render: h =>
        h(Tour, {
          props: { tourData: dataPackage }
        })
    }).$mount('#bananas-tour')
  }
}
